import React from 'react';
import { ShieldCheck, Lock, CreditCard, ArrowRight } from 'lucide-react';
export function PurchaseSection() {
  return <section id="compra" className="py-16 bg-blue-900 text-white px-4 scroll-mt-20" data-id="element-92">
      <div className="max-w-4xl mx-auto" data-id="element-93">
        <div className="text-center mb-10" data-id="element-94">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-95">
            👉 Toma la mejor decisión ahora
          </h2>
          <p className="text-xl text-blue-200" data-id="element-96">
            🎓 Invierte en estudiar mejor, no en estudiar más
          </p>
        </div>

        <div className="bg-white text-gray-900 rounded-3xl shadow-2xl overflow-hidden max-w-3xl mx-auto border-4 border-yellow-400" data-id="element-97">
          <div className="bg-yellow-400 p-4 text-center" data-id="element-98">
            <p className="font-bold text-blue-900 text-lg" data-id="element-99">
              🎁 Llévate los 4 bonos incluidos sin costo adicional
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-100">
            <h3 className="text-2xl md:text-3xl font-bold text-blue-900 mb-2" data-id="element-101">
              📘 Accede ahora a Mapas Mentales de Anatomía Humana
            </h3>
            <p className="text-gray-500 mb-8" data-id="element-102">
              Acceso vitalicio + Actualizaciones futuras
            </p>

            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-103">
              <span className="text-2xl text-gray-400 line-through font-medium" data-id="element-104">
                $39.99
              </span>
              <span className="text-6xl font-extrabold text-green-600" data-id="element-105">
                $13.99
              </span>
            </div>

            <a href="https://pay.hotmart.com/A104341314E?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="block w-full bg-green-600 hover:bg-green-500 text-white font-bold text-2xl py-5 px-8 rounded-xl shadow-[0_4px_0_rgb(21,128,61)] hover:shadow-[0_2px_0_rgb(21,128,61)] hover:translate-y-[2px] transition-all mb-6 animate-pulse" data-id="element-106">
              🔘 QUIERO ACCEDER AHORA
            </a>

            <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-gray-500" data-id="element-107">
              <div className="flex items-center gap-2" data-id="element-108">
                <Lock className="w-4 h-4" data-id="element-109" />
                <span data-id="element-110">Compra 100% segura</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-111">
                <ShieldCheck className="w-4 h-4" data-id="element-112" />
                <span data-id="element-113">Pago protegido</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-114">
                <CreditCard className="w-4 h-4" data-id="element-115" />
                <span data-id="element-116">Acceso inmediato</span>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-6 border-t border-gray-100 flex flex-col md:flex-row items-center justify-center gap-6" data-id="element-117">
            <ShieldCheck className="w-16 h-16 text-blue-900" data-id="element-118" />
            <div className="text-center md:text-left" data-id="element-119">
              <p className="font-bold text-lg text-gray-900" data-id="element-120">
                Garantía de Satisfacción de 7 Días
              </p>
              <p className="text-gray-600 text-sm max-w-md" data-id="element-121">
                Si el material no cumple con tus expectativas, te devolvemos el
                100% de tu dinero. Sin preguntas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}